// extracted by mini-css-extract-plugin
export default {"pro":"Pro_pro__zGkKB","icon":"Pro_icon__iAiuK","textContent":"Pro_textContent__3-dbz","header":"Pro_header__I5Myd","description":"Pro_description__dY9M6"};